// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"bc1977d9","138":"3560a80c","189":"55f2e93d","204":"1d786162","208":"9a3fe06b","480":"f86f4641","906":"89d7dec9"}[chunkId] + ".chunk.js";
};